import { useEffect, useState } from 'react';
import { BsFiletypePdf } from 'react-icons/bs';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { getAppVersion, handlePdfView } from "../../../common/actions/commonActions";
import TablePagination from '../../../common/components/TablePagination';
import commonLabels from "../../../common/labels/common_en.json";
import commonHILabels from "../../../common/labels/common_hi.json";
import { formatToDDMMYYYY_HHMMSS } from '../../../helpers/Datetime';
import { getAllGrievanceListPagination, getSingleGrievance } from '../actions/masterManagementAction';
import masterLabels from '../labels/master_en.json';
import GrievanceResponseForm from './GrievanceResponseForm';

let headerRow = [
    "Sr. No.",
    "Token No.",
    "Grievance Type",
    "Grievance Sub Type",
    "Advertisement Name",
    "Description",
    "Document",
    "Submitted At",
    "Contact",
    "Action"
];

const GrievanceAdminList = () => {
    const [listCurrentPage, setListCurrentPage] = useState(0);
    const [grievanceResponse, setGrievanceResponse] = useState(false)
    const [pageNo, setPageNo] = useState(false);
    let [grievanceNameToSearch, setGrievanceNameToSearch] = useState(false);
    let [searchMode, setSearchMode] = useState(false);
    let [addDocument, setAddDocument] = useState(false);
    let [grievanceAccess, setGrievanceAccess] = useState(true);

    const dispatch = useDispatch();
    const { grievanceList } = useSelector((state) => state.masterManagementReducer, shallowEqual)
    let rowPerPage = 10;

    useEffect(() => {
        dispatch(getAllGrievanceListPagination(0, rowPerPage));
        dispatch(getAppVersion())

    }, [rowPerPage])

    const getGrivance = (id) => {
        dispatch(getSingleGrievance(id))
        setGrievanceResponse(true)
    }
    const searchDoc = (grievanceNameToSearch) => {
        setSearchMode(Number(new Date()));
        dispatch(getAllGrievanceListPagination(0, rowPerPage, grievanceNameToSearch));
    }

    useEffect(() => {
        const timerOut = setTimeout(() => {
            if (!grievanceList) {
                setGrievanceAccess(false)
            } else {
                setGrievanceAccess(true)
            }
        }, 2000)

        return (() => {
            clearTimeout(timerOut)
        })
    })

    return (
        <div className='p-1'>
            {grievanceResponse ? <GrievanceResponseForm setGrievanceResponse={setGrievanceResponse} grievanceResponse={grievanceResponse} setListCurrentPage = {setListCurrentPage} listCurrentPage={listCurrentPage} /> : <div>

                {grievanceList && grievanceList?.isAllowed ? <>
                    <div className="p-3 bg-color  mt-1">
                        <h5>
                            {commonLabels.GRIEVANCE.GRIEVANCE_INFO} : {commonHILabels.GRIEVANCE.GRIEVANCE_INFO}
                        </h5>
                    </div>
                    <div className="row mt-2">
                        <div className="pt-4 col-md-12">
                            <h5 className="bottom-dotted-line align-left p-1" >
                                {commonLabels.GRIEVANCE.GRIEVANCE_DETAILS}: {commonHILabels.GRIEVANCE.GRIEVANCE_DETAILS}
                            </h5>
                        </div>
                    </div>

                    {/* Grievance Table  */}
                    <div className="border border-light text-center">
                        <div className='form-group'>
                            <div className='row'>
                                <div className='col-md-3'>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="grievanceNameToSearch"
                                        value={grievanceNameToSearch == false ? "" : grievanceNameToSearch}
                                        placeholder={masterLabels.documentTypeList.BUTTON_SEARCH_PlaceHolder}
                                        onChange={event => { setGrievanceNameToSearch(event.target.value); setSearchMode(false); }}
                                        maxLength="50"
                                    />
                                </div>
                                <div className='col-md-1'>
                                    <button className='form-control  btn btn-primary custom_button  button_search  ' onClick={() => { searchDoc(grievanceNameToSearch); }}><i className="fa fa-search" type="button" ></i></button>
                                </div>
                                <div className='col-md-6'></div>
                            </div>
                        </div>
                        <table className="table table-bordered m-0 position-relative grievanceTable">
                            <thead className="table-primary">
                                <tr>
                                    {headerRow.map((ele, index) => (
                                        <th scope="col" key={index}>
                                            {ele}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody className="f10">
                                {grievanceList.grievances ? grievanceList?.grievances?.map((ele, index) => {
                                    if (!ele.isDeleted) {
                                        return (
                                            <tr key={index}>
                                                <td className="word-break text-center">{ele.id}</td>
                                                <td className="word-break">{ele.ticketNumber && ele.ticketNumber ? ele.ticketNumber : "NA"}</td>
                                                <td className="word-break">{ele.typeName ? ele.typeName : "NA"}</td>
                                                {/* {
                                                    commonLabels.GRIEVANCE_TYPES_REGISTRAION.filter((e) => e.id === ele.type).length > 0
                                                        ? <td>{commonLabels.GRIEVANCE_TYPES_REGISTRAION.find((e) => e.id === ele.type)?.label}</td>
                                                        : <td></td>
                                                } */}
                                                <td className="word-break">{ele.subTypeName ? ele.subTypeName : "NA"}</td>
                                                <td className="word-break">{ele.advtNumber ? ele.advtNumber : "NA"}</td>
                                                <td className="word-break  col-md-4">{ele.description ? ele.description : "NA"}</td>
                                                <td className="word-break text-center">
                                                    <button
                                                        onClick={() => handlePdfView(ele.documentData)}
                                                        title="View PDF"
                                                        style={{
                                                            background: "none",
                                                            border: "none",
                                                            padding: "0",
                                                            cursor: "pointer",
                                                        }}
                                                    >{ele.documentData ? <BsFiletypePdf
                                                        className="errorText"
                                                        size={30}
                                                        style={{ cursor: "pointer" }}
                                                    /> : "No Doucument"}
                                                    </button>
                                                </td>
                                                <td className="word-break">  {ele.createdAt && <span className="text-primary"> {formatToDDMMYYYY_HHMMSS(ele.createdAt)}  </span>}   </td>
                                                <td className="word-break w-6">  {ele.mobile}  </td>
                                                <td><button className='res-btn border border-1 rounded-1 p-1 pe-auto text-center ' onClick={() => getGrivance(ele.id)}> {ele.remarks ? <span className='text-success'>Resolved</span> : <span className='text-danger'>Pending</span>} </button></td>
                                            </tr>
                                        );
                                    }
                                }) : grievanceList?.map((ele, index) => {
                                    if (!ele.isDeleted) {
                                        return (
                                            <tr key={index}>
                                                <td className="word-break text-center">{ele.id}</td>
                                                <td className="word-break">{ele.ticketNumber && ele.ticketNumber ? ele.ticketNumber : "NA"}</td>
                                                <td className="word-break">{ele.typeName ? ele.typeName : "NA"}</td>

                                                {/* {
                                                    commonLabels.GRIEVANCE_TYPES_REGISTRAION.filter((e) => e.id === ele.type).length > 0
                                                        ? <td>{commonLabels.GRIEVANCE_TYPES_REGISTRAION.find((e) => e.id === ele.type)?.label}</td>
                                                        : <td></td>
                                                } */}
                                                <td className="word-break">{ele.subTypeName ? ele.subTypeName : "NA"}</td>
                                                <td className="word-break">{ele.advtNumber ? ele.advtNumber : "NA"}</td>
                                                <td className="word-break  col-md-4">{ele.description ? ele.description : "NA"}</td>
                                                <td className="word-break text-center">
                                                    <button
                                                        onClick={() => handlePdfView(ele.documentData)}
                                                        title="View PDF"
                                                        style={{
                                                            background: "none",
                                                            border: "none",
                                                            padding: "0",
                                                            cursor: "pointer",
                                                        }}
                                                    >{ele.documentData ? <BsFiletypePdf
                                                        className="errorText"
                                                        size={30}
                                                        style={{ cursor: "pointer" }} /> : "No Doucument"}
                                                    </button>
                                                </td>
                                                {/* <td>hdiuwdi</td> */}
                                                <td className="word-break w-10">  {ele.createdAt && <span className="text-primary"> {formatToDDMMYYYY_HHMMSS(ele.createdAt)}  </span>}   </td>
                                                <td className="word-break">  {ele.mobile}  </td>
                                                <td><button className=' border border-1 rounded-1 p-1 pe-auto text-center' onClick={() => getGrivance(ele.id)}> {ele.remarks ? <span className='text-success'>Resolved</span> : <span className='text-danger'>Pending</span>} </button></td>
                                            </tr>
                                        );
                                    }
                                })}
                            </tbody>
                        </table>
                        {grievanceList && grievanceList.length === 0 ? (
                            <h6 className="text-muted text-center">
                                {commonLabels.GRIEVANCE.NO_DATA_TO_DISPLAY}
                            </h6>
                        ) : (
                            ""
                        )}
                        <TablePagination
                            paginationFor="all_grievance_list_pagination"
                            rowPerPage={rowPerPage}
                            setListCurrentPage={setListCurrentPage}
                            listCurrentPage={listCurrentPage}
                            textToSearch={grievanceNameToSearch}
                            totalCount={grievanceList.totalRecords}
                            searchMode={searchMode}
                        />
                    </div>
                </> : (grievanceList && !grievanceList?.isAllowed && !grievanceAccess) && <div className="premium-permission-wrapper">
                    <div className="premium-permission-box">
                        <h1>{commonLabels.COMMON.ACCESS_DENIED}</h1>
                        <p> {grievanceList.message} </p>
                    </div>
                </div>
                }
            </div>}
        </div >
    )
}

export default GrievanceAdminList
